module.exports = "\n<div class=\"content\" [@routeAnimation] = \"prepareRoute(outlet)\">\n  <router-outlet #outlet=\"outlet\"></router-outlet>\n</div>"